import { render, staticRenderFns } from "./FlowTriggerFrequency.step.vue?vue&type=template&id=0d28cea1&scoped=true&"
import script from "./FlowTriggerFrequency.step.vue?vue&type=script&lang=js&"
export * from "./FlowTriggerFrequency.step.vue?vue&type=script&lang=js&"
import style0 from "./FlowTriggerFrequency.step.vue?vue&type=style&index=0&id=0d28cea1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d28cea1",
  null
  
)

export default component.exports